<template>
  <div class="font-sans min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col">
    <div class="flex-grow pb-12 lg:pb-20">
      <!-- Hero Section -->
      <section
        class="relative bg-blue-50 dark:bg-gray-900 pt-6 pb-8 lg:pt-10 lg:pb-12 overflow-hidden border-b border-gray-100 dark:border-gray-700"
      >
        <div
          class="absolute inset-0 opacity-[0.03] pointer-events-none overflow-hidden flex flex-wrap content-start"
        >
          <svg
            v-for="i in 150"
            :key="i"
            class="w-16 h-16 text-[#1a2b4b] dark:text-gray-700 m-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            ></path>
          </svg>
        </div>

        <div class="relative max-w-screen-xl mx-auto px-4 z-10">
          <router-link
            to="/"
            class="inline-flex items-center text-sm font-semibold text-[#1a2b4b] dark:text-gray-200 hover:text-yellow-500 dark:hover:text-[#C5B47A] mb-6 transition-colors group"
          >
            <svg
              class="w-5 h-5 mr-2 transform group-hover:-translate-x-1 transition-transform"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15 19l-7-7 7-7"
              ></path>
            </svg>
            Kembali ke Lowongan
          </router-link>

          <div
            class="bg-white dark:bg-gray-800 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] dark:shadow-none border border-gray-100 dark:border-gray-700 p-5 md:p-10 relative z-20"
          >
            <div class="flex flex-col md:flex-row items-center gap-6 text-center md:text-left">
              <div
                class="w-20 h-20 bg-blue-100 dark:bg-blue-900 rounded-2xl flex items-center justify-center text-[#1a2b4b] dark:text-blue-300 shrink-0"
              >
                <svg class="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  ></path>
                </svg>
              </div>
              <div>
                <h1 class="text-2xl md:text-4xl font-black text-[#1a2b4b] dark:text-white mb-2">
                  Kebijakan Privasi
                </h1>
                <p class="text-sm md:text-base text-gray-500 dark:text-gray-300 font-medium">
                  Panduan penggunaan layanan lokerjambi.co.id
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Content -->
      <main class="max-w-4xl mx-auto px-4 mt-10">
        <div class="space-y-6">
          <div
            class="bg-white dark:bg-gray-800 rounded-3xl shadow-sm dark:shadow-none border border-gray-100 dark:border-gray-700 p-6 md:p-10"
          >
            <p class="text-base md:text-lg text-gray-600 dark:text-gray-300 leading-relaxed mb-10">
              Kami menghormati privasi Anda. Kebijakan ini menjelaskan cara kami mengumpulkan,
              menggunakan, dan melindungi informasi pribadi Anda. Dengan menggunakan situs ini, Anda
              dianggap menyetujui kebijakan ini.
            </p>

            <div class="space-y-10">
              <!-- Section 1 -->
              <section>
                <h2
                  class="text-lg md:text-xl font-black text-[#1a2b4b] dark:text-white mb-4 flex items-center"
                >
                  <span
                    class="w-8 h-8 bg-blue-50 dark:bg-blue-900 text-blue-600 dark:text-blue-300 rounded-lg flex items-center justify-center mr-3 text-sm shrink-0"
                    >01</span
                  >
                  Informasi yang Dikumpulkan
                </h2>
                <ul class="space-y-3 ml-2 md:ml-11">
                  <li
                    class="flex items-start text-gray-600 dark:text-gray-300 text-sm md:text-base"
                  >
                    <svg
                      class="w-5 h-5 mr-3 text-green-500 dark:text-green-400 shrink-0 mt-0.5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="3"
                        d="M5 13l4 4L19 7"
                      ></path>
                    </svg>
                    <span
                      >Kami dapat mengumpulkan data pribadi seperti email, nomor telepon, nama
                      perusahaan, serta alamat website atau Instagram perusahaan. Selain itu, kami
                      juga mengumpulkan data otomatis seperti alamat IP, jenis perangkat, browser,
                      dan aktivitas pengguna melalui cookies.</span
                    >
                  </li>
                </ul>
              </section>

              <!-- Section 2 -->
              <section>
                <h2
                  class="text-lg md:text-xl font-black text-[#1a2b4b] dark:text-white mb-4 flex items-center"
                >
                  <span
                    class="w-8 h-8 bg-blue-50 dark:bg-blue-900 text-blue-600 dark:text-blue-300 rounded-lg flex items-center justify-center mr-3 text-sm shrink-0"
                    >02</span
                  >
                  Perlindungan Data
                </h2>
                <ul class="space-y-3 ml-2 md:ml-11">
                  <li
                    class="flex items-start text-gray-600 dark:text-gray-300 text-sm md:text-base"
                  >
                    <svg
                      class="w-5 h-5 mr-3 text-green-500 dark:text-green-400 shrink-0 mt-0.5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="3"
                        d="M5 13l4 4L19 7"
                      ></path>
                    </svg>
                    <span
                      >Kami menerapkan langkah-langkah keamanan yang sesuai untuk melindungi data
                      Anda dari akses atau penggunaan yang tidak sah. Kami tidak membagikan data
                      kepada pihak ketiga secara melanggar hukum. Namun, perlu diketahui bahwa tidak
                      ada sistem keamanan internet yang sepenuhnya aman.</span
                    >
                  </li>
                </ul>
              </section>

              <!-- Warning Box -->
              <div
                class="bg-red-50 dark:bg-red-900/20 rounded-3xl p-6 md:p-8 border-2 border-red-100 dark:border-red-500/20 relative overflow-hidden"
              >
                <div class="absolute -right-4 -top-4 w-24 h-24 bg-red-500/5 rounded-full"></div>
                <h2
                  class="text-lg md:text-xl font-black text-red-700 dark:text-red-400 mb-4 flex items-center"
                >
                  <svg class="w-6 h-6 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                    ></path>
                  </svg>
                  Himbauan Keamanan
                </h2>
                <p
                  class="text-sm md:text-base text-red-900/80 dark:text-red-200/80 leading-relaxed mb-4 font-medium"
                >
                  Kami menyarankan Anda untuk menjaga kerahasiaan data pribadi dan berhati-hati
                  terhadap penipuan, termasuk lowongan kerja palsu. Kami menegaskan bahwa tidak ada
                  proses rekrutmen yang memungut biaya. Silakan laporkan jika menemukan indikasi
                  penipuan atau spam.
                </p>
              </div>

              <!-- Section 3 -->
              <section>
                <h2
                  class="text-lg md:text-xl font-black text-[#1a2b4b] dark:text-white mb-4 flex items-center"
                >
                  <span
                    class="w-8 h-8 bg-blue-50 dark:bg-blue-900 text-blue-600 dark:text-blue-300 rounded-lg flex items-center justify-center mr-3 text-sm shrink-0"
                    >03</span
                  >
                  Perubahan Kebijakan
                </h2>
                <ul class="space-y-4 ml-2 md:ml-11">
                  <li
                    class="flex items-start text-gray-500 dark:text-gray-400 text-xs md:text-sm italic"
                  >
                    <span class="mr-3 shrink-0">•</span>
                    <span
                      >Kebijakan ini dapat diperbarui sewaktu-waktu. Perubahan penting akan
                      diinformasikan melalui halaman ini. Kami menyarankan Anda untuk meninjau
                      kebijakan secara berkala.</span
                    >
                  </li>
                </ul>
              </section>

              <!-- Law Compliance -->
              <div
                class="bg-blue-900 dark:bg-gray-700 text-white rounded-3xl p-8 relative overflow-hidden shadow-xl shadow-blue-900/20 dark:shadow-none"
              >
                <div
                  class="absolute right-0 bottom-0 w-32 h-32 bg-white/5 rounded-full -mr-16 -mb-16"
                ></div>
                <h2 class="text-lg md:text-xl font-black mb-4 flex items-center">
                  <svg
                    class="w-6 h-6 mr-3 text-blue-300 dark:text-blue-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"
                    ></path>
                  </svg>
                  Kontak
                </h2>
                <p class="text-blue-100/90 dark:text-gray-300 leading-relaxed text-sm">
                  Jika Anda memiliki pertanyaan, silakan hubungi kami melalui halaman bantuan.
                </p>
              </div>
            </div>
          </div>

          <div class="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
            <router-link
              to="/about"
              class="text-[#1a2b4b] dark:text-gray-200 font-bold hover:underline dark:hover:text-[#C5B47A]"
              >Tentang Kami</router-link
            >
            <span class="hidden sm:block text-gray-300 dark:text-gray-600">|</span>
            <router-link
              to="/contact"
              class="text-[#1a2b4b] dark:text-gray-200 font-bold hover:underline dark:hover:text-[#C5B47A]"
              >Hubungi Kami</router-link
            >
          </div>
        </div>
      </main>
    </div>
    <AppFooter />
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { initFlowbite } from 'flowbite';
import AppFooter from '../components/layout/AppFooter.vue';
import { useSeoMeta } from '../composables/useSeoMeta';

useSeoMeta({
  title: 'Kebijakan Privasi',
  description:
    'Pelajari cara Lokerjambi.co.id mengumpulkan, menggunakan, dan melindungi data pribadi Anda. Kami berkomitmen menjaga privasi pengguna sesuai UU No. 27 Tahun 2022 tentang Pelindungan Data Pribadi.',
  path: '/privacy-policy',
});

onMounted(() => {
  initFlowbite();
});
</script>
